module.exports = __webpack_public_path__ + "static/media/HCMM060.475e6ba2.jpg";